import * as React from 'react';
const MinusIcon = (props) => (
  <svg
    width='21'
    height='22'
    viewBox='0 0 21 22'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clip-path='url(#clip0_15_68)'>
      <path
        d='M10.5 0C4.71077 0 0 4.93423 0 11C0 17.0658 4.71077 22 10.5 22C16.2901 22 21 17.0658 21 11C21 4.93423 16.2892 0 10.5 0ZM10.5 20.2959C5.60704 20.2959 1.62664 16.126 1.62664 11C1.62664 5.87404 5.60704 1.7041 10.5 1.7041C15.393 1.7041 19.3734 5.87404 19.3734 11C19.3734 16.126 15.393 20.2959 10.5 20.2959Z'
        fill={props.color}
      />
      <path
        d='M14.5666 10.0713H6.43334C5.98438 10.0713 5.62 10.453 5.62 10.9234C5.62 11.3937 5.98438 11.7754 6.43334 11.7754H14.5666C15.0155 11.7754 15.3799 11.3937 15.3799 10.9234C15.3799 10.453 15.0155 10.0713 14.5666 10.0713Z'
        fill={props.color}
      />
    </g>
    <defs>
      <clipPath id='clip0_15_68'>
        <rect width='21' height='22' fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export default MinusIcon;
